import * as Yup from "yup";

import { getInjuriesSchema } from "Components/Form/RecentDamages/validation";
import { TextManager } from "Components/TextContext";
import { ErrorPrefix } from "Constants/constants";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagCabinRental } from "Utils/unleash/flags";
import { CabinContentsSum } from "../cabinContentsConstants";
import { CabinContentsProductDetailsFormValues } from "../cabinContentsInterfaces";

export const validationSchema =
  (): Yup.ObjectSchema<CabinContentsProductDetailsFormValues> => {
    const { getText } = TextManager;

    const enableRentalToggle = useUnleashFeatureFlag(
      FeatureFlagCabinRental.ENABLE_CABIN_RENTAL,
    );

    return Yup.object({
      hasElectricity: Yup.mixed<BooleanFormType>().required(
        getText("cabincontentsform.validation.haselectricity"),
      ),
      hasTapWater: Yup.mixed<BooleanFormType>().required(
        getText("cabincontentsform.validation.hastapwater"),
      ),
      hasRental: Yup.mixed<BooleanFormType>().when([], {
        is: () => enableRentalToggle,
        then: (schema) =>
          schema.required(getText("cabincontentsform.validation.hasrental")),
      }),
      rentalTimeExceedsOneMonthAYear: Yup.mixed<BooleanFormType>().when([], {
        is: () => !enableRentalToggle,
        then: (schema) =>
          schema
            .required(
              getText(
                "cabincontentsform.validation.rentaltimeexceedsonemonthayear_required",
              ),
            )
            .oneOf(
              [BooleanFormType.FALSE],
              ErrorPrefix.BREAKING +
                getText(
                  "cabincontentsform.validation.rentaltimeexceedsonemonthayear",
                ),
            ),
      }),
      contentsInsuranceSum: Yup.number()
        .required(
          getText("cabincontentsform.validation.contentsinsurancesum_required"),
        )
        .max(
          CabinContentsSum.UPPER_LIMIT,
          ErrorPrefix.BREAKING +
            getText(
              "cabincontentsform.validation.contentsinsurancesum_toohigh",
            ),
        )
        .min(
          CabinContentsSum.LOWER_LIMIT,
          getText("cabincontentsform.validation.contentsinsurancesum_toolow"),
        ),
    })
      .concat(getInjuriesSchema())
      .defined();
  };
